var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      paintOrder: "fill",
      strokeWidth: 0
    },
    d: "M 4.287 19.357 L 4.287 34.976 L 70.053 34.976 L 70.053 19.357 L 4.287 19.357 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      paintOrder: "fill",
      strokeWidth: 0
    },
    d: "M 75.808 19.357 L 91.428 19.357 L 91.428 55.529 L 20.728 55.529 L 20.728 76.081 L 4.287 76.081 L 4.287 39.91 L 75.808 39.91 L 75.808 19.357 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      paintOrder: "fill",
      strokeWidth: 0
    },
    d: "M 25.662 60.461 L 91.428 60.461 L 91.428 76.081 L 25.662 76.081 L 25.662 60.461 Z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/badge.d0bc388895741a5ac96c6c88df7bc330.svg";
export { ForwardRef as ReactComponent };